import { z } from 'zod';
/**
 * Entity-or-Suggestion Ref
 *
 * Discriminated-union ref used in tenant-governed entity slots
 * (successor teams/systems, helper systems, assigned-to, who-else-does-this).
 *
 * An entry in such a slot is either:
 *   - an `entity` ref → resolved against the slot's owning model (Team / System / etc.)
 *   - a `suggestion` ref → resolved against EntitySuggestion (pending or rejected,
 *     surfaced in the picker as a pending/rejected chip)
 *
 * When a suggestion is approved, every slot holding `{ type: 'suggestion', id: S }`
 * is rewritten in place to `{ type: 'entity', id: <resolvedEntityId> }`. Rejecting
 * leaves the ref in place so the user can dismiss the rejected chip explicitly.
 */ export const EntityOrSuggestionRefSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('entity'),
        id: z.string()
    }),
    z.object({
        type: z.literal('suggestion'),
        id: z.string()
    })
]);

//# sourceMappingURL=entity-suggestion-ref.schema.js.map